(ns fen.auth
  "Whether this window may talk to the server, and where its key is kept.

  One key per client, handed out once when a code was typed back, and shown
  as a bearer header from then on. It lives in localStorage: what is stored
  is not a password but this one device's key, and the server can take it
  away by forgetting the client entity it belongs to (see ento.auth)."
  (:require [kc.core :as kc]))

(def storage-key "ento.auth.v1")

(defonce AUTH (atom {:needed? false :client nil}))

(defn- storage []
  (when (exists? js/localStorage) js/localStorage))

(defn token []
  (when-let [s (storage)]
    (try (.getItem s storage-key) (catch :default _ nil))))

(defn save-token! [t]
  (when-let [s (storage)]
    (try (.setItem s storage-key t) (catch :default _ nil))))

(defn- clear-token! []
  (when-let [s (storage)]
    (try (.removeItem s storage-key) (catch :default _ nil))))

(defn needed!
  "The key this window had, if it had one, is no good any more - thrown away
  rather than kept and sent with every failing request until someone
  notices."
  []
  (when-not (:needed? @AUTH)
    (clear-token!)
    (swap! AUTH assoc :needed? true)))

(defn ok!
  "A call came back - so whatever key this window has is good. Guarded,
  because this runs on every poll and a needless swap is a needless redraw."
  []
  (when (:needed? @AUTH)
    (swap! AUTH assoc :needed? false)))

(defn satisfied!
  "A code was traded for a key. `client` is what the server said this window
  now is - {:client :client-8f2a1c6d :name \"Firefox on Linux\"} - kept so
  the window can say which device it is."
  [client]
  (swap! AUTH assoc :needed? false :client client))

(defn headers []
  (when-let [t (kc/str-trimmed-non-blank (token))]
    {"authorization" (str "Bearer " t)}))
